<template>
  <div class="mc-seg">
    <button
      v-for="opt in options"
      :key="opt.value"
      type="button"
      :class="{ 'is-on': value === opt.value }"
      @click="$emit('input', opt.value)"
    >
      {{ opt.label }}
    </button>
  </div>
</template>

<script>
export default {
  name: 'SegmentedControl',
  props: {
    // [{ label, value }, { label, value }]
    options: { type: Array, required: true },
    value: { type: [String, Boolean, Number], default: null },
  },
}
</script>

<style scoped>
.mc-seg {
  display: flex;
  background: #eff0f6;
  border-radius: 999px;
  padding: 3px;
  gap: 3px;
}

.mc-seg button {
  flex: 1;
  border: 0;
  background: transparent;
  font-family: inherit;
  font-size: 13.5px;
  font-weight: 600;
  color: #6e7191;
  padding: 10px 6px;
  border-radius: 999px;
  cursor: pointer;
  transition: 0.15s;
}

.mc-seg button.is-on {
  background: #fff;
  color: #003087;
  box-shadow: 0 1px 3px rgba(20, 20, 43, 0.12);
}
</style>
